import { FeatureLdg, InfoLdg, TestimonialType } from "types";

// Testimonial names to highlight on the homepage (Trustpilot reviews preferred)
// These will be displayed in a sleek section below the broker marquee
export const highlightedTestimonialNames: string[] = [
  "Seema Suresh",
  "David Perkins",
  "SHRAVAN YADAV",
];

export const infos: InfoLdg[] = [
  {
    title: "Empower your projects",
    description:
      "Unlock the full potential of your projects with our open-source SaaS platform. Collaborate seamlessly, innovate effortlessly, and scale limitlessly.",
    image: "/_static/illustrations/work-from-home.jpg",
    list: [
      {
        title: "Collaborative",
        description: "Work together with your team members in real-time.",
        icon: "laptop",
      },
      {
        title: "Innovative",
        description: "Stay ahead of the curve with access constant updates.",
        icon: "settings",
      },
      {
        title: "Scalable",
        description:
          "Our platform offers the scalability needed to adapt to your needs.",
        icon: "search",
      },
    ],
  },
  {
    title: "Seamless Integration",
    description:
      "Integrate our open-source SaaS seamlessly into your existing workflows. Effortlessly connect with your favorite tools and services for a streamlined experience.",
    image: "/_static/illustrations/work-from-home.jpg",
    list: [
      {
        title: "Flexible",
        description:
          "Customize your integrations to fit your unique requirements.",
        icon: "laptop",
      },
      {
        title: "Efficient",
        description: "Streamline your processes and reducing manual effort.",
        icon: "search",
      },
      {
        title: "Reliable",
        description:
          "Rely on our robust infrastructure and comprehensive documentation.",
        icon: "settings",
      },
    ],
  },
];

export const features: FeatureLdg[] = [
  {
    title: "Real-time Options Scanning",
    description:
      "Our advanced algorithm scans the entire options market in real-time to find high-probability trading opportunities with the best risk-reward ratios.",
    link: "/dashboard/options",
    icon: "search",
  },
  {
    title: "Custom Alerts",
    description:
      "Create personalized alerts using natural language or technical criteria. Get notified via email, Discord, or Telegram when your specific trading conditions are met.",
    link: "/dashboard/alerts",
    icon: "bell",
  },
  {
    title: "Stock Watchlists",
    description:
      "Build and monitor custom watchlists of your favorite stocks. Track earnings dates, dividend events, and options opportunities specific to your selected tickers.",
    link: "/dashboard/watchlists",
    icon: "laptop",
  },
  /*{
    title: "Performance Analytics",
    description:
      "Track the historical performance of strategies and visualize key metrics with interactive charts. Refine your approach based on comprehensive data analysis.",
    link: "/dashboard/charts",
    icon: "chart",
  },
  {
    title: "Multi-Strategy Framework",
    description:
      "Access pre-built strategies like earnings plays, cash-secured puts, and covered calls, or create your own custom strategies with our flexible rule engine.",
    link: "/dashboard/options",
    icon: "settings",
  },
  {
    title: "Professional Fund Management",
    description:
      "Let our team of professionals manage your options portfolio with conservative strategies targeting 12% annual returns with lower volatility than the market.",
    link: "/fund",
    icon: "billing",
  },*/
];

export const testimonials: TestimonialType[] = [
  
  {
    id: "igor",
    name: "Igor",
    job: "Business Owner",
   // image: "/_static/landing/david-min.jpeg",
    review: "What you are building is great for the options market!",
    country: "Croatia"
  },
  {
    id: "virag",
    name: "Virag Kepes",
    job: "Options Seller",
    review: "great product",
    socialLink: "https://www.trustpilot.com/reviews/693053f021bd1ec9a8e0c397",
    socialIcon: "trustpilot",
    //secondarySocialLink: "https://www.linkedin.com/in/david-prelogovic/",
    //secondarySocialIcon: "linkedin",
    country: "USA"
  },
  {
    id: "david-perkins",
    name: "David Perkins",
    job: "Options Seller",
    review: "Brilliant layout and functionality. The AI feature is an invaluable time saver.",
    socialLink: "https://www.trustpilot.com/reviews/693726d8319048387aa848b5",
    socialIcon: "trustpilot",
    //secondarySocialLink: "https://www.linkedin.com/in/david-prelogovic/",
    //secondarySocialIcon: "linkedin",
    country: "USA"
  },
  {
    id: "nishan",
    name: "Nishan",
    job: "Software Engineering Manager, Microsoft",
    image: "/_static/landing/Microsoft-Logo-White.webp",
    review: "QuantWheel helped me find and sell my first Put! It was a profit as well.",
    //socialLink: "https://ie.trustpilot.com/reviews/68114736a1b3a5b4d0102516",
    //socialIcon: "trustpilot",
    //secondarySocialLink: "https://www.linkedin.com/in/david-prelogovic/",
    //secondarySocialIcon: "linkedin",
    country: "USA"
  },

  {
    id: "borna",
    name: "Borna",
    job: "Software Engineer",
   // image: "/_static/landing/david-min.jpeg",
    review: "After finding this page I started to realize how powerful this is and just sold my first Put!",
    //socialLink: "https://ie.trustpilot.com/reviews/68114736a1b3a5b4d0102516",
    //socialIcon: "trustpilot",
    //secondarySocialLink: "https://www.linkedin.com/in/david-prelogovic/",
    //secondarySocialIcon: "linkedin",
    country: "Croatia"
  },
  {
    id: "rene",
    name: "Rene.",
    job: "Software Engineer",
   // image: "/_static/landing/david-min.jpeg",
    review: "This is exactly what I needed! App already works very well and is useful to me. ",
    country: "Croatia"
  },
  {
    id: "seema",
    name: "Seema Suresh",
    job: "Senior Software Engineer @ Microsoft",
    image: "/_static/landing/seema.png",
    review: "My husband and I had been interested in the wheel options strategy for a long time, but the complexity of knowing what to buy and when—and the time it would take to figure everything out—kept us from getting started. QuantWheel has finally changed that. With its intuitive platform, clear guidance, and timely notifications, we now feel confident and informed. This is exactly the push we needed to finally begin our journey into options trading.",
    socialLink: "https://ie.trustpilot.com/reviews/68183d518f399913a8570be9",
    socialIcon: "trustpilot",
    secondarySocialLink: "https://www.linkedin.com/in/seemamithanthaya/",
    secondarySocialIcon: "linkedin",
    country: "USA"
  },
  {
    id: "shravan",
    name: "SHRAVAN YADAV",
    job: "Trader",
    review: "Amazing tool very happy to use. Quantwheel is a reliable and smooth platform. Easy to use, consistent, and backed by a helpful support team. Great for traders who want stable performance without complications. Highly recommended.",
    socialLink: "https://www.trustpilot.com/reviews/69210cba2ad9cb04775043c6",
    socialIcon: "trustpilot",
    country: "India"
  },
  
  {
    id: "david-prelogovic",
    name: "David Prelogovic",
    job: "PostDoc ML Researcher",
    image: "/_static/landing/david-min.jpeg",
    review: "The simplest and intuitive options selling tool I've seen so far. Clear interface, automatic notifications, powerful trading strategies, beginner friendly. Highly recommended!",
    socialLink: "https://ie.trustpilot.com/reviews/68114736a1b3a5b4d0102516",
    socialIcon: "trustpilot",
    secondarySocialLink: "https://www.linkedin.com/in/david-prelogovic/",
    secondarySocialIcon: "linkedin",
    country: "UK"
  },
  {
    id: "luka",
    name: "Luka Knezic",
    job: "TradeLocker CEO",
    image: "/_static/landing/luka-min.png",
    review: "QuantWheel saved me hours every week and gave me confidence I'm looking at the best options at any given time. It's become part of my weekly routine.",
    socialLink: "https://www.instagram.com/lukaknezic/",
    socialIcon: "instagram",
    country: "Croatia"
  },
  {
    id: "ivan",
    name: "Ivan Orehovec",
    job: "Engineering Manager @ MongoDB, ex Microsoft",
    image: "/_static/landing/ivan-min.png",
    review: "After 8 months with QuantWheel, my workflow is completely different. The system surfaces options I would have missed and the analysis is consistently more thorough than what I was doing manually.",
    socialLink: "https://www.linkedin.com/in/ivanorehovec/",
    socialIcon: "linkedin",
    country: "USA"
  },
  {
    id: "karlo",
    name: "Karlo Ivan Slatina",
    job: "Global Economy & Finance",
    image: "/_static/landing/karlo-min.jpeg",
    review: "User interface is clean, I am happy with how fast I got to learn to use it and trade with Quantwheel. I've been using other platforms before for option trading, but I warmly recommend this one even for beginners!",
    socialLink: "https://ie.trustpilot.com/reviews/6811b811b3a9797edb1c12c2",
    socialIcon: "trustpilot",
    secondarySocialLink: "https://www.linkedin.com/in/karlo-ivan-slatina/",
    secondarySocialIcon: "linkedin",
    country: "Korea"
  },
  {
    id: "anton",
    name: "Anton",
    job: "Software Engineer",
   // image: "/_static/landing/david-min.jpeg",
    review: "QuantWheel enabled me to jump-start my option selling experience. Providing an overview of a general score for each trade combined with the most relevant stock metrics and AI risk analysis tremendously simplified the process of discovering the best trades at any given time. The team behind QuantWheel is experienced, offering quick and reliable support.",
    country: "Croatia"
  },
];
